export default __webpack_public_path__ + "static/072-cdd6589f5f53f62f43af0977c0b49b2b.mp4";